import { useEffect } from 'react';
import { useMatch, useNavigate, Outlet } from 'react-router-dom';
import { Tabs, PermissionDenied, PermissionEnum, IconLoader } from '@ui/src';
import { useAppSelector } from '@store';
import {
  useLazyGetAmlDictionariesQuery,
  useLazyGetAmlBaseCurrenciesQuery,
  useLazyGetAmlCurrenciesQuery,
} from '../../store/dictionaries/services';

import ROUTES from '../../routes';

import cn from './individual-clients-risk.module.css';

const IndividualClientsRisk = () => {
  const match = useMatch(ROUTES.INDIVIDUAL_CLIENTS_RISK);

  const navigate = useNavigate();

  const { activePermissions, currencies, riskScoreRanges, baseCurrency } =
    useAppSelector((state) => state.amlDictionaries);

  const [getDictionaries] = useLazyGetAmlDictionariesQuery();
  const [getAmlBaseCurrency] = useLazyGetAmlBaseCurrenciesQuery();
  const [getAmlCurrencies] = useLazyGetAmlCurrenciesQuery();

  useEffect(() => {
    if (match) {
      navigate(ROUTES.INDIVIDUAL_CLIENTS_RISK_GEOGRAPHICAL);
    }
  }, [match]);

  useEffect(() => {
    if (!riskScoreRanges) {
      getDictionaries();
    }

    if (!currencies) {
      getAmlCurrencies();
    }

    if (!baseCurrency) {
      getAmlBaseCurrency();
    }
  }, [currencies, riskScoreRanges, baseCurrency]);

  useEffect(() => {
    let title = 'Individual clients risk';

    const companyName = localStorage.getItem('companyName');

    if (companyName) {
      title = `${title} | ${companyName}`;
    }

    document.title = title;
  }, []);

  let content = (
    <div className={cn.individualClientsRiskLoader}>
      <IconLoader />
    </div>
  );

  if (activePermissions) {
    if (!activePermissions.includes(PermissionEnum.SECTION_AML_KYC)) {
      content = <PermissionDenied />;
    } else {
      content = (
        <div className={cn.individualClientsRisk}>
          <div className={cn.individualClientsRiskTitle}>
            Individual clients risk
          </div>
          <div className={cn.individualClientsRiskTabsWrapper}>
            <Tabs
              itemClassName={cn.individualClientsRiskTabItem}
              tabs={[
                {
                  name: 'Geographical risk',
                  path: ROUTES.INDIVIDUAL_CLIENTS_RISK_GEOGRAPHICAL,
                },
                {
                  name: 'Volumes risk scores',
                  path: ROUTES.INDIVIDUAL_CLIENTS_RISK_VOLUMES,
                },
                {
                  name: 'Product/Service risk',
                  path: ROUTES.INDIVIDUAL_CLIENTS_RISK_PRODUCTS,
                },
                {
                  name: 'Delivery Channels',
                  path: ROUTES.INDIVIDUAL_CLIENTS_RISK_DELIVERY_CHANNELS,
                },
                {
                  name: 'Activity of the client',
                  path: ROUTES.INDIVIDUAL_CLIENTS_RISK_ACTIVITIES,
                },
                {
                  name: 'Source of funds',
                  path: ROUTES.INDIVIDUAL_CLIENTS_RISK_SOURCE_OF_FUNDS,
                },
              ]}
              enableRouting
            />
          </div>
          <Outlet />
        </div>
      );
    }
  }

  return content;
};

export default IndividualClientsRisk;
